import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { environment } from '@environements';
import { Pagination } from '@interfaces/index';
import { BACKGROUND_REQUEST } from '@interceptors/http-context';
import {
  Incident,
  IncidentGetAllParams,
  IncidentSeverity,
  IncidentTargetStatus,
} from '@incident/interfaces/incident.interface';

export type {
  Incident,
  IncidentGetAllParams,
  IncidentSeverity,
  IncidentTargetStatus,
} from '@incident/interfaces/incident.interface';

@Service()
export class IncidentService {
  private http = inject(HttpClient);
  private base = `${environment.SAAS_SERVICE}/incidents`;

  getAll(query: IncidentGetAllParams) {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(query)) {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    }
    return this.http.get<Pagination<Incident>>(this.base, { params });
  }

  getById(id: string) {
    return this.http.get<Incident>(`${this.base}/${id}`);
  }

  /** Severity is an operator's triage label; it changes nothing else. */
  updateSeverity(id: string, severity: IncidentSeverity) {
    return this.http.patch<Incident>(`${this.base}/${id}`, { severity });
  }

  changeStatus(id: string, status: IncidentTargetStatus) {
    return this.http.post<Incident>(`${this.base}/${id}/status`, { status });
  }

  /** The sidebar badge: how many reports still need an operator. */
  countOpen() {
    return this.http.get<Pagination<Incident>>(this.base, {
      params: new HttpParams().set('status', 'open').set('page', 1).set('perPage', 1),
      context: new HttpContext().set(BACKGROUND_REQUEST, true),
    });
  }
}
